import { render, staticRenderFns } from "./FormRoles.vue?vue&type=template&id=6012e737&lang=pug&"
import script from "./FormRoles.vue?vue&type=script&lang=js&"
export * from "./FormRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports